import { Outlet, useOutletContext } from "react-router-dom";
import LoaderWrapper from "./LoaderWrapper";

export default function ChildWrapper() {
  const outletContext = useOutletContext();
  const loading = outletContext?.loading || false;

  return (
        <div className="invoice-component">
      <LoaderWrapper loading={loading}>
        <Outlet />
      </LoaderWrapper>
    </div>
  );
}